import React, { useState, CSSProperties } from 'react';

interface EditableCellProps {
  value: number;
  field: string;
  style?: CSSProperties;
  onEdit: (field: string, value: number) => void;
  isEditing: boolean;
  onEditStart: () => void;
  onEditCancel?: () => void;
  disabled?: boolean;
}

const EditableCell: React.FC<EditableCellProps> = ({
  value,
  field,
  style = {},
  onEdit,
  isEditing,
  onEditStart,
  onEditCancel,
  disabled = false
}) => {
  const [tempValue, setTempValue] = useState(value.toString());

  const handleSubmit = () => {
    const numValue = parseFloat(tempValue);
    if (!isNaN(numValue)) {
      onEdit(field, numValue);
    } else {
      // 無効な値の場合は元の値に戻す
      setTempValue(value.toString());
      onEditCancel?.();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setTempValue(value.toString());
      onEditCancel?.();
    }
  };

  const handleBlur = () => {
    handleSubmit();
  };

  const handleClick = (e: React.MouseEvent) => {
    if (!disabled && !isEditing) {
      e.preventDefault();
      setTempValue(value.toString());
      onEditStart();
    }
  };

  if (isEditing) {
    return (
      <td className="editing-cell">
        <input
          type="number"
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoFocus
          style={{
            width: '100%',
            border: '2px solid #007bff',
            borderRadius: '4px',
            padding: '4px 8px',
            fontSize: '14px',
            textAlign: 'right'
          }}
        />
      </td>
    );
  }

  return (
    <td
      style={{
        ...style,
        cursor: disabled ? 'default' : 'pointer',
        padding: '8px 12px',
        textAlign: 'right',
        transition: 'background-color 0.2s',
        ...(disabled ? {} : { ':hover': { backgroundColor: '#f8f9fa' } })
      }}
      onClick={handleClick}
      className={`editable-cell ${disabled ? 'disabled' : ''}`}
      title={disabled ? '' : 'クリックして編集'}
    >
      {value.toLocaleString()}
    </td>
  );
};

export default EditableCell;